import React, { type ComponentProps, type ElementType } from 'react';

import { Link } from '@/shared/ui/primitives/Link';

import Markdown from '@/components/Markdown';
import { Z_INDEX } from '@/constants/z-index';
import WidgetMapper from '@/features/ai-chat/components/WidgetMapper/WidgetMapper';
import { GX_REGEX } from '@/features/ai-chat/lib/gxCodes';
import type { AIMessage } from '@/features/ai-chat/types/chat.types';
import Tooltip from '@/shared/ui/primitives/Tooltip';

import type { ExtraProps } from 'react-markdown';

const AssistantLink: ElementType<ComponentProps<'a'> & ExtraProps> = ({
  node,
  children,
  ...props
}) => (
  <Tooltip
    sx={{
      zIndex: Z_INDEX.panel
    }}
    title='Click to see index information'
    variant='secondary'
  >
    <Link
      {...props}
      color='textPrimary'
      rel='noopener noreferrer'
      sx={{ textDecorationColor: 'inherit' }}
      target='_blank'
    >
      {children}
    </Link>
  </Tooltip>
);

const AIContent = ({ msg }: { msg: AIMessage }) => {
  return (
    <>
      {msg.content.map(part => {
        switch (part.kind) {
          case 'text':
            return (
              <Markdown
                key={part.text}
                customMarkdown={{
                  a: AssistantLink
                }}
              >
                {part.text.replace(GX_REGEX, match => `[${match}](/${match})`)}
              </Markdown>
            );
          case 'tool_result':
            if (part.display === 'table') {
              return (
                <WidgetMapper
                  key={part.tool_call_id}
                  widgetData={part}
                />
              );
            }
            return null;
          default:
            return null;
        }
      })}
    </>
  );
};

export default AIContent;
